module.exports = __webpack_public_path__ + "static/media/fiesta-chicken.ef55633e.jpg";